$(function () {
  const mrkPreSelection = [{"Club Set":"4-pw (7 irons)","4 iron":true,"5 iron":true,"6 iron":true,"7 iron":true,"8 iron":true,"9 iron":true,"pw":true},{"Club Set":"5-gw (7 irons)","4 iron":false,"5 iron":true,"6 iron":true,"7 iron":true,"8 iron":true,"9 iron":true,"pw":true,"gw": true},{"Club Set":"5-pw (6 irons)","4 iron":false,"5 iron":true,"6 iron":true,"7 iron":true,"8 iron":true,"9 iron":true,"pw":true},{"Club Set":"6-pw (5 irons)","4 iron":false,"5 iron":false,"6 iron":true,"7 iron":true,"8 iron":true,"9 iron":true,"pw":true},{"Club Set":"single irons","4 iron":false,"5 iron":false,"6 iron":false,"7 iron":false,"8 iron":false,"9 iron":false,"pw":false}];
  const customConfiguration = 'single irons';
  initCustomOption();

  function initCustomOption(){
    $.ajax({
      url: 'https://customfit-api.affordablegolf.co.uk/GetOptions',
      type: 'POST',
      "headers": {
        "Content-Type": "application/json"
      },
      "data": JSON.stringify({
        "sku": window.mrkSku
      }),
      dataType: 'json',
      success: function(response) {
        $('.customtab-container').show();
        window.customSKU = response.sku;
        // Generate and insert HTML
        $('.mrk-custom-options-container').html('');
        let data = response; // Assuming the server returns the data object directly
        data.options.forEach(generateHTMLFromTemplate);
        window.customOptionsHTML = $('.mrk-custom-options-container').html();
        updateCheckboxes();
        updateIronCheckboxes();
        preSelectClub();
        if($('.block-swatch:not(.block-swatch--disabled):not(.mrk-simple-dot)').length>0)
          window.defaultCustomFit = false;
        if(window.defaultCustomFit){
          $('.customtab-container .mrk-standard').hide()
        }
        setTimeout(hideShowButton,50)
      },
      error: function(error) {
        $('.customtab-container').hide();
        $('.customtab.mrk-standard').click();
        console.error('Failed to fetch the data:', error);
      }
    });
  }
  function updateIronCheckboxes(){
    // Event listener for the select dropdown change
    $('.mrk-club-container input').off('change');
    $('.mrk-club-container input').on('change', function() {
      $('.mrk-custom-configuration').css('display', 'flex');
      window.customSelection = true;
      let selectedValue =$('.mrk-club-container input:checked').val().toLowerCase();
      if(selectedValue === customConfiguration){
        $('.mrk-checkbox-price .addon-text').hide();
        $('.form__input-wrapper').each(function() {
          $(this).removeClass('mrk-option-preselected');
          $(this).find('input[type=checkbox]').prop('checked', false);
        });
      } else {
        $('.mrk-checkbox-price .addon-text').show();

        let preSelectedSet = mrkPreSelection.find(set => (set['Club Set'].toLowerCase() === selectedValue));
        // console.log(preSelectedSet,mrkPreSelection);
        if (preSelectedSet) {
          $('.form__input-wrapper').each(function() {
            let clubType = $(this).find('input').val().toLowerCase();
            let shortClubType = clubType.substring(0, 2);
            if (preSelectedSet[clubType] || preSelectedSet[shortClubType]) {
              $(this).addClass('mrk-option-preselected');
              $(this).find('input[type=checkbox]').prop('checked', true);
            } else {
              $(this).removeClass('mrk-option-preselected');
              $(this).find('input[type=checkbox]').prop('checked', false);
            }
          });
        }
      }
    });
  }
  function preSelectClub(){
    $('.mrk-radio-btns[option-name="Hand"] input:eq(0)').prop('checked', true).trigger('change');
    $('.mrk-club-container input:eq(0)').prop('checked', true).trigger('change');
    $('.mrk-option-preselected input:checked:eq(0)').trigger('change');

  }
  function syncCheckboxesWithRadios() {
    let selectedClubs = {}; // To hold the state of checkboxes

    // Collect selected checkboxes
    $('.mrk-custom-configuration input[type="checkbox"]').each(function() {
      let clubType = $(this).val().toLowerCase().substring(0, 2);
      selectedClubs[clubType] = $(this).is(':checked');
    });

    // Compare the selected checkboxes with predefined sets in mrkPreSelection
    let matchedSet = mrkPreSelection.find(set => {
      return Object.keys(set).every(club => {
        if (club === "Club Set") return true; // Skip "Club Set" key

        // Normalize both club name and checkbox value, and compare the first 2 characters
        let normalizedClub = club.toLowerCase().substring(0, 2); // Get the first 2 characters
        let normalizedSelectedClub = selectedClubs[club.toLowerCase().substring(0, 2)]; // Get the first 2 characters of selected club

        console.log(normalizedClub, normalizedSelectedClub, set[club]); // Debugging log

        // Compare the preselected set value with the checkbox value
        return set[club] === normalizedSelectedClub;
      });
    });


    // console.log(matchedSet, 'mrk');
    // If a match is found, trigger the radio button for that set
    if (matchedSet) {
      let matchedClubSet = matchedSet['Club Set'];
      $('.mrk-club-container input[type="radio"]').each(function() {
        if($(this).is(':checked')) {
          return;
        }
        let radioValue = $(this).val().toLowerCase();
        if (radioValue === matchedClubSet.toLowerCase()) {
          $(this).prop('checked', true).trigger('change'); // Check and trigger the change event
        }
      });
    }
  }
  function updateCheckboxes(){
    $('.mrk-custom-options .checkbox-wrapper [type="checkbox"]').off('change');
    $('.mrk-custom-options .checkbox-wrapper [type="checkbox"]').on('change', function() {
      var checkboxName = $(this).attr('name');
      var checkedValues = $('.mrk-custom-options .form__input-wrapper .checkbox-wrapper [type="checkbox"][name="' + checkboxName + '"]:checked')
      .map(function() { return this.value; })
      .get()
      .join(',');
      $(this).closest('.option-values-wrapper')
        .find('[type="hidden"]')
        .val(checkedValues);
      // New functionality to sync checkboxes with radios
      syncCheckboxesWithRadios();
    });
    $('.mrk-custom-options .checkbox-wrapper [type="checkbox"]:checked').trigger('change');  
  }
  $('.customtab').on('click', function() {
    // Remove active class from all tabs
    $('.customtab').removeClass('mrk-active');
    // Add active class to the clicked tab
    $(this).addClass('mrk-active');

    // Hide both options by default
    $('.mrk-config-options, .mrk-custom-options').hide();

    // Check if clicked tab has class 'mrk-standard' or 'mrk-custom'
    if($(this).hasClass('mrk-standard')) {
      $('.mrk-config-options').show();
      $('.product-form__add-button-custom-product').hide();
      $('.product-form__add-button').show();

      if($('.mrk-custom-options-container .product-form__option').length){
        window.customOptionsHTML = $('.mrk-custom-options-container').html();
        $('.mrk-custom-options-container').html('');
        triggerSimpleVariant();
      }

      var productPrices = $('.price-list');
      var currencyFormat = window.theme.currencyCodeEnabled ? window.theme.moneyWithCurrencyFormat : window.theme.moneyFormat;

      $(productPrices).each(function() {

        if (window.mrkCurrentVariant.compare_at_price && window.mrkCurrentVariant.compare_at_price > window.mrkCurrentVariant.price) {
          // Show with compare price
          $(this).html('<span class="price price--highlight"><span class="visually-hidden">Sale price</span>'
            .concat(window.mrkCurrency.formatMoney(window.mrkCurrentVariant.price, currencyFormat), "</span>")
            .concat('<span class="price price--compare"><span class="visually-hidden">Regular price</span>')
            .concat(window.mrkCurrency.formatMoney(window.mrkCurrentVariant.compare_at_price, currencyFormat)) +'</span>');
        } else {
          // No price to compare
          $(this).html("<span class=\"price\"><span class=\"visually-hidden\">"
            .concat(window.languages.productSalePrice, "</span>")
            .concat(window.mrkCurrency.formatMoney(window.mrkCurrentVariant.price, currencyFormat), "</span>"));
        }

      });

      $('.product-form__payment-container').removeClass('mrk-custom-fit-active');

    } else if($(this).hasClass('mrk-custom')) {
      $('.product-form__add-button-custom-product').show();
      $('.product-form__add-button').hide();
      $('.mrk-custom-options').show();

      if(window.customOptionsHTML != undefined){
        $('.mrk-custom-options-container').html(window.customOptionsHTML);
        updateCheckboxes();
        updateIronCheckboxes();
        childSelectChangeHandle();
        preSelectClub()
      }else{
        initCustomOption();
      }

      setTimeout(hideShowButton,10)
      setTimeout(calculateFinalPrice,10)
      $('.product-form__payment-container').addClass('mrk-custom-fit-active');
    }
  });
  function hideShowButton(){
    $('.customtab.mrk-active').each(function(){
      if($(this).hasClass('mrk-standard')) {
        $('.product-form__add-button-custom-product').hide();
        $('.product-form__add-button').show();
        $('.product-block-list__wrapper').css('min-height', '0px');
        if($('[data-option-position="1"]:checked').val() == '.'){
          $('[data-option-position="1"]:eq(0)').next('label').click();
          $('[data-option-position="2"]:eq(0)').next('label').click();
          $('[data-option-position="3"]:eq(0)').next('label').click();
        }
      } else if($(this).hasClass('mrk-custom')) {
        $('.product-form__add-button-custom-product').show();
        $('.product-form__add-button').hide();
        $('.product-block-list__wrapper').css('min-height', `${$('.card.card--collapsed.card--sticky').height()}px`)
        $('.product-form__payment-container').addClass('mrk-custom-fit-active'); //Added this line to solve the custom-fit order issue
      }
    });
    // $('.mrk-radio:first-child input').prop('checked',true).trigger('change')
  }
  function triggerSimpleVariant(){
    $('.mrk-config-options select')[0].dispatchEvent(new Event('change', {'bubbles': true,'cancelable': true}));
  }
  function generateHTMLFromTemplate(option, index_) {
    let $template;
    let $optionWrapper = $(`<div class="option-values-wrapper" option-name="${option.Option_display_name}"></div>`);

    switch (option.Option_type) {
      case "dropdown":
        $template = $($('#dropdown-html').html());
        $template.find('.product-form__option-name').text(option.Option_display_name);
        let hasParentChild = option.values.some(val => val.Option_value.includes('---'));

        if (hasParentChild) {
          // Adding the class to the parent div
          $template.addClass('mrk-parent-child-selection');

          // Create a map for parent to children relationships
          let parentChildrenMap = {};
          option.values.forEach(val => {
            let [parent, child] = val.Option_value.split('---');
            parentChildrenMap[parent] = parentChildrenMap[parent] || [];
            parentChildrenMap[parent].push({
              value: child,
              price: val.Option_price
            });
          });

          // Create a new div for the parent select
          let $parentDiv = $('<div class="mrk-parent-select kldjl"></div>');

          // Move the label and select-wrapper into the new div
          $template.find('.product-form__option-name, .select-wrapper').appendTo($parentDiv);

          // Parent dropdown
          let $parentSelect = $parentDiv.find('select');
          $parentSelect.attr('name', `properties[${option.Option_display_name} Parent]`);
          Object.keys(parentChildrenMap).forEach(parent => {
            $parentSelect.append($('<option></option>').attr('value', parent).text(parent));
          });

          // Append the new parent div to the template
          $template.append($parentDiv);

          // Clone the template for the child dropdown
          let $childTemplate = $($('#dropdown-html').html());
          $childTemplate.find('.product-form__option-name').text("Shaft");
          let $childSelect = $childTemplate.find('select');
          $childSelect.attr('name', `properties[Shaft]`);
          $childTemplate.hide(); // Initially hide the child dropdown

          // Append child template to the main template
          $template.append($childTemplate);
          window.parentChildrenMap = parentChildrenMap;
          // Event listener for parent dropdown change
          $parentSelect.on('change', function() {
            let selectedParent = this.value;
            $childSelect.empty(); // Clear previous child options
            $childSelect.append($('<option value="" disabled selected>-- Please Select --</option>'));
            parentChildrenMap[selectedParent].forEach(child => {
              var price = child.price * 100;
              var formattedPrice = window.mrkCurrency.formatMoney(price, window.theme.moneyFormat);
              let displayValue = child.price > 0 ? `${child.value} +${formattedPrice}` : child.value;
              $childSelect.append($('<option></option>').attr('data-price', child.price).attr('value', child.value).text(displayValue));
            });

            $childTemplate.show(); // Show child dropdown when a parent is selected
          });
        } else {
          // Standard dropdown
          let $select = $template.find('select');
          $select.attr('name', `properties[${option.Option_display_name}]`);
          option.values.forEach(val => {
            let basePrice = val.Option_price;
            if(option.Option_display_name == 'Clubs')
              basePrice = val.base_price;
            var price = basePrice * 100;
            var formattedPrice = window.mrkCurrency.formatMoney(price, window.theme.moneyFormat);
            let displayValue = basePrice > 0 ? `${val.Option_value} +${formattedPrice}` : val.Option_value;
            $select.append($('<option></option>').attr('value', displayValue).attr('data-price', basePrice).text(displayValue));
          });
        }
        break;            

      case "inputText":
        $template = $($('#inputText-html').html());
        $template.find('.form__floating-label').text(option.Option_display_name);
        let $input = $template.find('input');
        $input.attr('name', `properties[${option.Option_display_name}]`);
        $input.attr('placeholder', option.placeholder);
        break;
      case "radio":
        $template = $($('#radio-html').html());
        $template.find('.product-form__option-name').text(option.Option_display_name);
        var prop = `properties`;
        if(option.Option_display_name.toLowerCase() == 'clubs'){
          $template.addClass('mrk-club-container');
          prop = `custom`;
        }
        option.values.forEach(val => {
          var formatedPrice = window.checkboxPrice = window.mrkCurrency.formatMoney(val.Option_price * 100,window.theme.moneyFormat);
          let displayLabel = val.Option_price > 0 ? `${val.Option_value}` : val.Option_value; // +${formatedPrice}
          var basePrice = Number(val.base_price);
          if(option.Option_display_name.toLowerCase() == 'clubs')
            var price = basePrice;
            else
            var price = val.Option_price;
          let $radioBoxDiv = $template.find('.mrk-radio').clone();
          let isPreselected = val.Preselect;
          $radioBoxDiv.find('input[type="radio"]')
            .attr('value', val.Option_value)
            .attr('name', `${prop}[${option.Option_display_name}]`)
            .attr('id', val.Option_value.replace(' ', '-').toLowerCase())
            .attr('data-price', price).prop('checked',isPreselected);
          $radioBoxDiv.find('label').attr('for', val.Option_value.replace(' ', '-').toLowerCase()).text(displayLabel);
          $optionWrapper.append($radioBoxDiv);
        });
        $optionWrapper.addClass('mrk-radio-btns');
        $template.find('.mrk-radio').replaceWith($optionWrapper);
        break;
      case "checkbox":
        let $hiddenInput = $('<input>').attr({
          type: 'hidden',
          name: `properties[${option.Option_display_name}]`,
          id: `hidden_${option.Option_display_name.replace(' ', '')}`
        });
        $optionWrapper.prepend($hiddenInput);
        if(option.Option_display_name.toLowerCase() == customConfiguration || option.Option_display_name.toLowerCase().includes(customConfiguration)){
          $optionWrapper.addClass(`mrk-custom-configuration`);
        }
        $template = $($('#checkbox-html').html());

        option.values.forEach(val => {
          var formatedPrice = window.checkboxPrice = window.mrkCurrency.formatMoney(val.Option_price * 100,window.theme.moneyFormat);
          let displayLabel = val.Option_price > 0 ? `${val.Option_value}` : val.Option_value; // +${formatedPrice}
          let $checkBoxDiv = $template.clone();
          let isPreselected = val.Preselect;
          $checkBoxDiv.find('input[type="checkbox"]')
            .attr('value', val.Option_value)
            .attr('name', `${option.Option_display_name}-${index_}`)
            .attr('id', val.Option_value)
            .attr('data-price', val.Option_price).prop('checked',isPreselected);
          $checkBoxDiv.find('label').attr('for', val.Option_value).text(displayLabel);
          if(isPreselected)
            $checkBoxDiv.addClass('mrk-option-preselected');
          $optionWrapper.append($checkBoxDiv);
        });
        $optionWrapper.append(`<div class="mrk-checkbox-price">Add <span class="addon-price">${window.checkboxPrice}</span> per <span class="addon-text">additional</span> club.</div>`);
        // Append option wrapper to container and exit early
        $('.mrk-custom-options-container').append($optionWrapper);
        return;

    }

    // Append to container
    $('.mrk-custom-options-container').append($template);
  }
  function childSelectChangeHandle(){
    $('.mrk-parent-select select').on('change', function() {
      let selectedParent = this.value;
      var $childSelect = $(this).parents('.mrk-parent-child-selection').find('.product-form__option select');
      var $childTemplate = $(this).parents('.mrk-parent-child-selection').find('.product-form__option');
      $childSelect.empty(); // Clear previous child options
      $childSelect.append($('<option value="" disabled selected>-- Please Select --</option>'));
      window.parentChildrenMap[selectedParent].forEach(child => {
        var price = child.price * 100;
        var formattedPrice = window.mrkCurrency.formatMoney(price, window.theme.moneyFormat);
        let displayValue = child.price > 0 ? `${child.value} +${formattedPrice}` : child.value;
        $childSelect.append($('<option></option>').attr('data-price', child.price).attr('value', child.value).text(displayValue));
      });

      $childTemplate.show(); // Show child dropdown when a parent is selected
    });
  }
  function calculateTotalPrice() { 
    let total = 0;
    var numberOfIron = 0;
    var baseSelector = $('.mrk-club-container input:checked');
    var selected_basePrice = 0;//parseFloat($('.mrk-club-container input:checked option:checked').attr('data-price'));
    if(Number($('.mrk-club-container input:checked').attr('data-price')) > 0 ){
      selected_basePrice = Number($('.mrk-club-container input:checked').attr('data-price'));
    }

    let numberOfPreselectedInputs = 0; // Declare numberOfPreselectedInputs in a higher scope

    if ($('.mrk-club-container input:checked').val() != '' && selected_basePrice != 0) {
      numberOfIron = parseFloat($(baseSelector).val().split('(')[1].split(' ')[0]) + $('.mrk-custom-configuration .form__input-wrapper:not(.mrk-option-preselected) input:checked').length;
    } else if (selected_basePrice == 0) {
      numberOfIron = $('.mrk-custom-configuration .form__input-wrapper input:checked').length;
    }

    if (Number($('.mrk-option-preselected input:checked').length) != Number($('.mrk-option-preselected input').length)) {
      // Reset selected_basePrice to 0
      selected_basePrice = 0;
      // Count the number of checked inputs with class .mrk-option-preselected
      numberOfPreselectedInputs = $('.mrk-custom-configuration .mrk-option-preselected input:checked').length; // Assign value to numberOfPreselectedInputs
      // Log the count to the console
      console.log("Number of .mrk-option-preselected input:checked:", numberOfPreselectedInputs);

      // Calculate the total price based on the prices of preselected options
      $('.mrk-custom-configuration .mrk-option-preselected input:checked').each(function() {
        selected_basePrice = selected_basePrice + parseFloat($(this).attr('data-price'));
      });
    }

    $('.mrk-custom-configuration .form__input-wrapper:not(.mrk-option-preselected) input:checked').each(function() {
      selected_basePrice = selected_basePrice + parseFloat($(this).attr('data-price'))
    });

    if (window.mrkBasePrice > 0) {
      selected_basePrice = window.mrkBasePrice;
      numberOfIron = 1;
    }

    // Check for selected options in dropdowns with data-price > 0
    if (Number($('.mrk-option-preselected input:checked').length) != Number($('.mrk-option-preselected input').length)) {
      // When the condition is true
      $(".mrk-custom-options-container .product-form__single-selector-custom:not(.mrk-club-container input:checked)").each(function() {
        let optionPrice = parseFloat($(this).find('option:selected').data('price'));
        // console.log("Option Price:", optionPrice);
        // console.log("numberOfIron:", numberOfIron);
        // console.log("Base Price:", selected_basePrice);
        if (optionPrice > 0) {
          total += (optionPrice * numberOfPreselectedInputs); // Use numberOfPreselectedInputs here
        }
      });
    } else {
      // When the condition is false
      $(".mrk-custom-options-container .product-form__single-selector-custom:not(.mrk-club-container input:checked)").each(function() {
        let optionPrice = parseFloat($(this).find('option:selected').data('price'));
        // console.log("Option Price:", optionPrice);
        // console.log("numberOfIron:", numberOfIron);
        // console.log("Base Price:", selected_basePrice);
        if (optionPrice > 0) {
          total += (optionPrice * numberOfIron); // Use numberOfIron here
        }
      });
    }


    total = total + selected_basePrice;
    // Check for non-blank input fields
    $(".mrk-custom-options-container .form__field.form__field--text").each(function() {
      if ($(this).val().trim() !== '') {
        // Assuming you would want to count the price for non-empty input fields
        let inputPrice = $(this).data('price');
        if (inputPrice && parseFloat(inputPrice) > 0) {
          total += parseFloat(inputPrice);
        }
      }
    });

    return total;
  }
  function calculateFinalPrice(){
    let tPrice = calculateTotalPrice()*100;
    var productPrices = $('.price-list');
    var currencyFormat = window.theme.currencyCodeEnabled ? window.theme.moneyWithCurrencyFormat : window.theme.moneyFormat;

    $(productPrices).each(function(){
      if(tPrice == 0){
        $(this).html('Please Select Clubs')
      }else {
      $(this).html("<span class=\"price\"><span class=\"visually-hidden\">"
        .concat(window.languages.productSalePrice, "</span>")
        .concat(window.mrkCurrency.formatMoney(tPrice, currencyFormat), "</span>"));
      }
    });

    $('.customtab.mrk-active').each(function(){
      if($(this).hasClass('mrk-standard')) {

        $(productPrices).each(function(){
          if (window.mrkCurrentVariant.compare_at_price && window.mrkCurrentVariant.compare_at_price > window.mrkCurrentVariant.price) {
            // Show with compare price
            $(this).html('<span class="price price--highlight"><span class="visually-hidden">Sale price</span>'
              .concat(window.mrkCurrency.formatMoney(window.mrkCurrentVariant.price, currencyFormat), "</span>")
              .concat('<span class="price price--compare"><span class="visually-hidden">Regular price</span>')
              .concat(window.mrkCurrency.formatMoney(window.mrkCurrentVariant.compare_at_price, currencyFormat)) +'</span>');
          } else {
            // No price to compare
            $(this).html("<span class=\"price\"><span class=\"visually-hidden\">"
              .concat(window.languages.productSalePrice, "</span>")
              .concat(window.mrkCurrency.formatMoney(window.mrkCurrentVariant.price, currencyFormat), "</span>"));
          }
        });
      }
    })

    setInterval(hideShowButton,500);
  }
  // Call this function whenever you need the updated price. For instance:
  $(document).on('change', '.mrk-club-container input, .mrk-custom-options-container .product-form__single-selector-custom,.mrk-custom-options-container .checkbox,.mrk-custom-options-container .form__field.form__field--text', calculateFinalPrice);
  $('.make-this-active').click();

  function getUrlVars() {
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for(var i = 0; i < hashes.length; i++)
  {
      hash = hashes[i].split('=');
      // vars.push(hash[0]);
      // vars[hash[0]] = hash[1];
      return hash[1];
    }
    return vars;
  }



  if($("body").hasClass("template-product")){

    var variants = [];
    for (let i = 0; i < window.MAKEBECOOL_BUNDLES.product.variants.length; i++) {
      var v = window.MAKEBECOOL_BUNDLES.product.variants[i];
      if(v.inventory_policy == "continue"){
        variants.push(v.id);  
      }
    }

    var default_or_selected = $("#default_product_variant").val();
    if(default_or_selected == 1){
      if($('[name="properties[Delivery]"]').length){
        $('[name="properties[Delivery]"]').prop("checked", true);
      }else{
        $('.product-form').append('<input style="display:none;" type="radio" name="properties[Delivery]" value="5 To 7 Working Days" checked="checked">'); 
      }
    }else{
      if($('[name="properties[Delivery]"]').length){
        $('[name="properties[Delivery]"]').prop("checked", false);
      }else{
        $('.product-form').append('<input style="display:none;" type="radio" name="properties[Delivery]" value="5 To 7 Working Days">');  
      }            
    }

    function checkValueExists(variantId, variants){
      for (let index = 0; index < variants.length; index++) {
        var vid = variants[index];
        if(vid == variantId){
          return 1;
        }
      }
    }

    setInterval(function() {
      variantId = getUrlVars("variant");

      if(checkValueExists(variantId, variants) == 1) {
        $('[name="properties[Delivery]"]').prop("checked", true);
      } else {

        $('[name="properties[Delivery]"]').prop("checked", false);
      }  
    }, 500);  
  }


  $('[data-action="mrk-add-to-cart"]').click(function (e) {
    e.preventDefault(); 
    var requiredFields = [];

    $('.product-form__single-selector-custom').each(function() {
      var select = $(this);
      var label = select.parents('.product-form__option').find('label').text();

      if (select.val() === '' || select.val() === null) {
        requiredFields.push(label);
      }
    });

    var customOptionLength  = $('.mrk-custom-configuration input:checked').length;

    if(window.customSelection && customOptionLength == 0){
      alert(`Please Select Clubs Options.`);
      return
    }else if (requiredFields.length > 0) {
      alert('The following fields are required: ' + requiredFields.join(', '));
      return
    }

    var btnTxt = $('[data-action="mrk-add-to-cart"]').text();
    $('[data-action="mrk-add-to-cart"]').text('Loading...').prop('disabled',true);

    $.ajax({
      url: 'https://customfit-api.affordablegolf.co.uk/createProduct', 
      type: 'POST',
      "headers": {
        "Content-Type": "application/json"
      },
      "data": JSON.stringify({
        "title": current_product.title,
        "sku": window.customSKU,
        "vendor": current_product.vendor,
        "image": 'https:' + current_product.featured_image,
        "price": calculateTotalPrice(),
        "collectionId": window.collectionId,
        "tags": window.tags || []
      }),
      dataType: 'json',
      success: function(response) {
        var variantId = response.variants[0].id;
        let ltoValue = $(".lto").text().trim();
        if(!variantId){
          alert('Please try again!')
          return;
        }
        setTimeout(function(){
          // Select the existing form
          var $form = $('.product-block-list__item--info .product-form');
          $form.find('[name="id"]').remove();
          // Create a new hidden input for "id" and set its value to the variant ID
          var $idInput = $('<input>').attr({
            type: 'hidden',
            name: 'id',
            value: variantId
          });

          if(ltoValue){
            $form.append(`<input type="hidden" name="properties[Delivery]" value="${ltoValue}">`); 
          }

          // Append the new input to the form
          $form.append($idInput);

          // Remove the product-id input if it exists
          $form.find('[name="product-id"]').remove();

          // Serialize the form
          var formData = $form.serialize();
          console.log(formData);
          // Perform AJAX request to submit the form
          $.ajax({
            type: "POST",
            url: "/cart/add.js", // Shopify's add-to-cart URL
            data: formData,
            dataType: "json",
            success: function(response) {
              // Dispatch the 'product:added' event on success
              window.mrkProductClass.element.dispatchEvent(new CustomEvent('product:added', {
                bubbles: true,
                detail: {
                  variant: null, // Update this as needed
                  quantity: $form.find('[name="quantity"]').val()
                }
              }));

              $('.product-block-list__item--info .product-form input[name="properties[Delivery]"]').remove();

              console.log("Product added to cart:", response);
            },
            error: function(error) {
              console.error("Error adding product to cart:", error);
            }
          });
        },300);
        setTimeout(function(){
          $('[data-action="mrk-add-to-cart"]').text(btnTxt).prop('disabled',false);
        },600)
      },
      error: function(error) {
        console.error('Failed to fetch the data:', error);
      }
    });
  });

})
// document.addEventListener('varaintUnavailable', function(e) {
//   $(e.detail).each(function() { 
//   var $checkedInput = $(this).find('input:checked');

//   if ($checkedInput.length) {
//     var $blockSwatch = $checkedInput.closest('.block-swatch');

//     if ($blockSwatch.hasClass('block-swatch--disabled')) {
//       var $swatchList = $blockSwatch.closest('.block-swatch-list');

//       if ($swatchList.length) {
//         // Find the first .block-swatch that is not disabled
//         var $enabledSwatch = $swatchList.find('.block-swatch:not(.block-swatch--disabled)').first();

//         if ($enabledSwatch.length) {
//           // Find the input within this swatch and trigger a check
//           $enabledSwatch.find('input').prop('checked', true).trigger('change');
//         }
//       }
//     }
//   }
// });
// });
